var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImgContentGray"},[_c('div',{staticClass:"ImgContent"},[_c('div',{staticClass:"ImgTitle"},[_vm._v(" 关注圆桌星球，获取最新动态 ")]),_c('div',{staticClass:"ImgContentImg"},[_c('div',{staticClass:"Imgone"}),_c('div',{staticClass:"Imgtwo"}),_c('div',{staticClass:"Imgthree"}),_c('div',{staticClass:"Imgfour"}),_c('div',{staticClass:"Imgfive"})])])])
}]

export { render, staticRenderFns }